function prediction_hillslope(){
	var ai_model_list = ajax_call(publicPath + "/napi/simulate/debrisaieventlist"),
		ai_model_list_html_string = "",
		ai_debris_id_mapping = {"185":"新北DF011","186":"新北DF020","187":"新北DF012","188":"新北DF013","189":"新北DF014","190":"新北DF015","191":"新北DF016","192":"新北DF017","193":"新北DF018","194":"新北DF019","195":"新北DF003","196":"新北DF004","197":"新北DF005","198":"新北DF006","199":"新北DF065","200":"新北DF066","201":"新北DF067","202":"新北DF068","203":"新北DF069","204":"新北DF062","205":"新北DF081","206":"新北DF082","207":"新北DF221","208":"新北DF223","209":"新北DF073","210":"新北DF074","211":"新北DF075","212":"新北DF076","213":"新北DF077","214":"新北DF078","215":"新北DF079","216":"新北DF222","217":"新北DF080","218":"新北DF063","219":"新北DF064","220":"新北DF070","221":"新北DF071","222":"新北DF072","223":"新北DF083","224":"新北DF053","225":"新北DF054","226":"新北DF055","227":"新北DF220","228":"新北DF052","229":"新北DF023","230":"新北DF024","231":"新北DF029","232":"新北DF025","233":"新北DF026","234":"新北DF027","235":"新北DF028","236":"新北DF021","237":"新北DF022","238":"新北DF188","239":"新北DF189","240":"新北DF186","241":"新北DF183","242":"新北DF187","243":"新北DF185","244":"新北DF184","245":"新北DF001","246":"新北DF002","247":"新北DF120","248":"新北DF119","249":"新北DF116","250":"新北DF117","251":"新北DF118","252":"新北DF112","253":"新北DF113","254":"新北DF114","255":"新北DF115","256":"新北DF192","257":"新北DF197","258":"新北DF198","259":"新北DF191","260":"新北DF195","261":"新北DF196","262":"新北DF193","263":"新北DF194","264":"新北DF190","265":"新北DF124","266":"新北DF125","267":"新北DF232","268":"新北DF127","269":"新北DF128","270":"新北DF129","271":"新北DF126","272":"新北DF121","273":"新北DF122","274":"新北DF123","275":"新北DF214","276":"新北DF235","277":"新北DF216","278":"新北DF217","279":"新北DF218","280":"新北DF215","281":"新北DF211","282":"新北DF212","283":"新北DF213","284":"新北DF030","285":"新北DF031","286":"新北DF032","287":"新北DF033","288":"新北DF034","289":"新北DF035","290":"新北DF036","291":"新北DF037","292":"新北DF041","293":"新北DF042","294":"新北DF038","295":"新北DF039","296":"新北DF040","297":"新北DF229","298":"新北DF230","299":"新北DF103","300":"新北DF231","301":"新北DF104","302":"新北DF105","303":"新北DF151","304":"新北DF152","305":"新北DF156","306":"新北DF157","307":"新北DF154","308":"新北DF155","309":"新北DF153","310":"新北DF008","311":"新北DF007","312":"新北DF009","313":"新北DF010","314":"新北DF109","315":"新北DF110","316":"新北DF108","317":"新北DF107","318":"新北DF106","319":"新北DF111","320":"新北DF219","321":"新北DF084","322":"新北DF085","323":"新北DF093","324":"新北DF094","325":"新北DF228","326":"新北DF102","327":"新北DF101","328":"新北DF098","329":"新北DF099","330":"新北DF100","331":"新北DF095","332":"新北DF089","333":"新北DF090","334":"新北DF091","335":"新北DF224","336":"新北DF225","337":"新北DF226","338":"新北DF227","339":"新北DF234","340":"新北DF088","341":"新北DF092","342":"新北DF096","343":"新北DF097","344":"新北DF233","345":"新北DF086","346":"新北DF087","347":"新北DF043","348":"新北DF044","349":"新北DF045","350":"新北DF046","351":"新北DF047","352":"新北DF048","353":"新北DF049","354":"新北DF050","355":"新北DF051","356":"新北DF162","357":"新北DF173","358":"新北DF174","359":"新北DF175","360":"新北DF165","361":"新北DF166","362":"新北DF167","363":"新北DF160","364":"新北DF182","365":"新北DF161","366":"新北DF168","367":"新北DF169","368":"新北DF170","369":"新北DF171","370":"新北DF172","371":"新北DF177","372":"新北DF159","373":"新北DF158","374":"新北DF163","375":"新北DF164","376":"新北DF176","377":"新北DF178","378":"新北DF179","379":"新北DF180","380":"新北DF181","381":"新北DF210","382":"新北DF200","383":"新北DF201","384":"新北DF202","385":"新北DF203","386":"新北DF206","387":"新北DF207","388":"新北DF208","389":"新北DF209","390":"新北DF199","391":"新北DF204","392":"新北DF205","393":"新北DF056","394":"新北DF060","395":"新北DF059","396":"新北DF057","397":"新北DF058","398":"新北DF130","399":"新北DF131","400":"新北DF132","401":"新北DF133","402":"新北DF134","403":"新北DF135","404":"新北DF143","405":"新北DF144","406":"新北DF145","407":"新北DF146","408":"新北DF147","409":"新北DF137","410":"新北DF138","411":"新北DF139","412":"新北DF140","413":"新北DF141","414":"新北DF142","415":"新北DF136","416":"新北DF148","417":"新北DF149","418":"新北DF150","419":"新北DF061"},
		debris_basic_data = debris_flow_swcb()[0].toGeoJSON(),
		debris_object = {};
	debris_basic_data.features.forEach(function(element){
		debris_object[element.properties.Debrisno] = element;
	});
	if (ai_model_list) {
		ai_model_list.forEach(function(element){
			ai_model_list_html_string += '<option value="' + element.predict_id + '">' + element.predict_ts.slice(0,16) + " 達預警數：" + element.debris_count + '條</option>';
		});
	} else {
		toast_open("土石流預報API介接異常")
	}
	$("#prediction_hillslope").html(
		'<h5 class="font-weight-bold mb-0"><i class="fas fa-info-circle mr-2"></i>坡地災情預測功能說明</h5>'+
		'<h6 class="text-justify mt-1">為新北市消防局透過分析國內各單位坡地資料，所發展的多模式坡地預測模型(包含統計、AI與力學模式)，最後透過氣象局降雨預報資料，即可推估未來新北市所有土石流發生機率以及流動範圍，而每一次預報可預測未來24小時趨勢走向。</h6>'+
		'<div class="input-group mt-2 d-none">'+
		  	'<div class="input-group-prepend">'+
		    	'<label class="input-group-text">選擇預報方法</label>'+
		  	'</div>'+
		  	'<select class="custom-select" id="prediction_hillslope_method_selector">'+
		  		'<option value="ai">AI模式&力學模式</option>' + 
		  		'<option value="rti">RTI模式(統計方法)</option>' + 
		  	'</select>'+
		'</div>'+
		'<div class="input-group mt-2" id="prediction_hillslope_event_selector">'+
		  	'<div class="input-group-prepend">'+
		    	'<label class="input-group-text">選擇預報事件</label>'+
		  	'</div>'+
		  	'<select class="custom-select">'+
		  		ai_model_list_html_string + 
				'<option value="2015080900">2015-08-09 00:00 達預警數：30條</option>' +
		  	'</select>'+
		'</div>'+
		'<button type="button" class="btn btn-success btn-sm btn-block mt-2 function-log" function-log-id="7" id="prediction_hillslope_trig">查詢</button>'+
		'<div id="early_hillslope_content" class="mt-2 pt-2 border-t-normal"></div>'
	);

	$("#prediction_hillslope_method_selector").change(function(){
		var target_method = $("#prediction_hillslope_method_selector").val();
		switch(target_method){
			case "rti":
				$("#prediction_hillslope_event_selector").css("display", "none");
				break;
			case "ai":
				$("#prediction_hillslope_event_selector").css("display", "");
				break;
		};
	});

	$("#prediction_hillslope_trig").click(function(){
		$("#map_clear").click();
		var result_geojson = {type: "FeatureCollection", features: []},
			target_method = $("#prediction_hillslope_method_selector").val(),
			town_sta = {},
			town_table_html_string = "";
		switch(target_method){
			case "rti":
				var event_data = ajax_call(publicPath + "/cloud/edp2/rti/");
				event_data.forEach(function(element){
					debris_object[element.debrisno].properties.event_name = "RTI即時預測";
					debris_object[element.debrisno].properties.model_id = element.debrisno;
					debris_object[element.debrisno].properties.rti_status = element.status;
					debris_object[element.debrisno].properties.rti70 = element.rti70;
					debris_object[element.debrisno].properties.time = element.rti_json_ts;
					result_geojson.features.push(
						debris_object[element.debrisno]
					);
					if (element.status != "None") {
						var this_town_region = debris_object[element.debrisno].properties.Town01;
						if (town_sta[this_town_region] == undefined) {
							town_sta[this_town_region] = 0;
						};
						town_sta[this_town_region] += 1;
						town_table_html_string +=
							'<tr>'+
								'<td>' + debris_object[element.debrisno].properties.Town01 + '</td>'+
								'<td>' + debris_object[element.debrisno].properties.Full.slice(6,9) + '</td>'+
								'<td>' + debris_object[element.debrisno].properties.Debrisno.slice(2,7) + '</td>'+
								'<td>' + debris_object[element.debrisno].properties.DW_number + '</td>'+
								'<td>' + debris_object[element.debrisno].properties.Roadname + '</td>'+
								'<td class="d-none">' + element.debrisno + '</td>'+
							'</tr>';
					};
				});
				break;
			case "ai":
				var event_name = $("#prediction_hillslope_event_selector select").val(),
					event_data = ajax_call(publicPath + "/cloud/edp2/debris_event/" + event_name),
					rti_event_data = ajax_call(publicPath + "/cloud/edp2/rti/");
				if (event_data.length != 0) {
					event_data.forEach(function(element){
						if (element.debris_id != null) {
							debris_object[ai_debris_id_mapping[element.debris_id]].properties.event_name = event_name;
							debris_object[ai_debris_id_mapping[element.debris_id]].properties.model_id = element.debris_id;
							result_geojson.features.push(
								debris_object[ai_debris_id_mapping[element.debris_id]]
							);
							var this_town_region = debris_object[ai_debris_id_mapping[element.debris_id]].properties.Town01;
							if (town_sta[this_town_region] == undefined) {
								town_sta[this_town_region] = 0;
							};
							town_sta[this_town_region] += 1;
							town_table_html_string +=
								'<tr>'+
									'<td>' + debris_object[ai_debris_id_mapping[element.debris_id]].properties.Town01 + '</td>'+
									'<td>' + debris_object[ai_debris_id_mapping[element.debris_id]].properties.Full.slice(6,9) + '</td>'+
									'<td>' + debris_object[ai_debris_id_mapping[element.debris_id]].properties.Debrisno.slice(2,7) + '</td>'+
									'<td>' + debris_object[ai_debris_id_mapping[element.debris_id]].properties.DW_number + '</td>'+
									'<td>' + debris_object[ai_debris_id_mapping[element.debris_id]].properties.Roadname + '</td>'+
									'<td class="d-none">' + ai_debris_id_mapping[element.debris_id] + '</td>'+
								'</tr>';
						}
					});
				}
				rti_event_data.forEach(function(element){
					debris_object[element.debrisno].properties.rti_status = element.status;
					debris_object[element.debrisno].properties.rti70 = element.rti70;
					debris_object[element.debrisno].properties.time = element.rti_json_ts;
				});
				break;
		};

		var debris_layer = L.geoJSON(result_geojson, {
			style: function(feature){
				var result;
				if (feature.properties.event_name == "RTI即時預測") {
					if (feature.properties.rti_status != "None") {
						result = {
							color: "#e85a71",
							weight: 5
						};
					} else {
						result = {
							color: "#3ac569",
							weight: 5
						};
					}
				} else {
					result = {
						color: "#e85a71",
						weight: 5
					};
				}
				return result;
			}
		}).on('click', onClick);

		$("#early_hillslope_content").html(
			'<h5 class="font-weight-bold mb-0"><i class="fas fa-table"></i>行政區土石流預警統計與列表</h5>'+
			'<div class="h-300 w-100" id="hillslope_region_early_chart"></div>' +
			'<table class="table table-sm table-pointer table-hover" id="early_hillslope_region_table" width="100%" height="100%" class="p-cursor">'+
				'<thead class="thead-dark">'+
					'<tr>'+
						'<th>區域</th>'+
						'<th>村里</th>'+
						'<th>編號</th>'+
						'<th>保全對象</th>'+
						'<th>鄰近道路</th>'+
						'<th class="d-none">id</th>'+
					'</tr>'+
				'</thead>'+
				'<tbody>'+
					town_table_html_string +
				'</tbody>'+
			'</table>'
		);
        $('#early_hillslope_region_table').DataTable();
		overlay_dataset["prediction_hillslope_layer"] = L.layerGroup([debris_layer]).addTo(map);

		var region_name_list = Object.keys(town_sta).sort(function(a,b){return town_sta[b]-town_sta[a];}),
			data_array = [];

		region_name_list.forEach(function(element){
			data_array.push(town_sta[element]);
		});

		Highcharts.chart('hillslope_region_early_chart', {
            chart: {
                type: 'column'
            },
		    legend: {
		        align: 'right',
		        verticalAlign: 'top',
		        x: 0,
		        y: -10,
		        floating: true,
		        enabled: false
		    },
            title: {
                text: ''
            },
            xAxis: {
                categories: region_name_list,
            labels: {
                step: 1,
                style: {
                    fontWeight: 'bold',
                    color: 'rgba(0, 0, 0, 1)',
                    fontSize: '14px'
                },
                useHTML: true,
                formatter: function(){
                    var string = this.value.slice(0, 1) + "<br>" + this.value.slice(1, 2)
                    return string;
                }
            }
            },
            yAxis: {
                min: 0,
                title: {
                    text: '達預警潛勢溪流數量'
                },
                stackLabels: {
                    enabled: true,
                    style: {
                        fontWeight: 'bold',
                        color: (Highcharts.theme && Highcharts.theme.textColor) || 'black'
                    }
                }
            },
            tooltip: {
                headerFormat: '<b>{point.x}</b><br/>',
                pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}處溪流</b> <br/>',
                shared: true
            },
            plotOptions: {
                column: {
                    stacking: 'normal',
                    dataLabels: {
                        enabled: false,
                        color: (Highcharts.theme && Highcharts.theme.dataLabelsColor) || 'white'
                    }
                },
                series: {
                    cursor: 'pointer',
                    point: {
                        events: {
                            click: function () {
                                var query_condition = this.category;
                                // map
                                var target_geojson;
                                overlay_dataset["Basic_map"].features.forEach(function(element){
                                    if (element.properties.TOWNNAME == query_condition) {
                                        target_geojson = element;
                                    }
                                });
                                if (overlay_dataset["temp_map"] != undefined) {
                                    map.removeLayer(overlay_dataset["temp_map"]);
                                }
                                overlay_dataset["temp_map"] = L.geoJson(target_geojson,{
                                     color: "#e85a71",
                                     weight: 4,
                                     fill: false,
                                     interactive: false
                                }).addTo(map);
                                map.fitBounds(overlay_dataset["temp_map"].getBounds());
                            }
                        }
                    }
                }
            },
            series: [{
                name: "達預警",
                color: '#E31A1C',
                data: data_array
            }]
        });
	});

	$("#early_hillslope_content").on("click", "tr", function(){
		var this_id = $(this).find("td").eq(5).html();
		var this_layer = L.geoJSON(debris_object[this_id]);
		map.fitBounds(this_layer.getBounds());
	});

	function onClick(e){
		var this_marker = e.layer.feature.properties,
			method_info_html_string = "",
			village_info_html = ''
		try {
			village_info_html = 
				'<tr>'+
					'<th scope="col">里長姓名</th>'+
					'<td scope="col">' + this_marker.village_info["姓名"] + '</td>'+
				'</tr>'+
				'<tr>'+
					'<th scope="col">里辦公處地址</th>'+
					'<td scope="col">' + this_marker.village_info["里辦公處地址"] + '</td>'+
				'</tr>'+
				'<tr>'+
					'<th scope="col">里辦電話</th>'+
					'<td scope="col">' + this_marker.village_info["里辦電話"] + '</td>'+
				'</tr>'
		} catch (error) {}
		if (this_marker.event_name == "RTI即時預測") {
			method_info_html_string +=
				'<h4 class="font-weight-bold">二、土石流RTI即時預測資訊</h4>'+
				'<div class="row">' +
					'<div class="col-4">' +
						'<table class="table table-bordered text-center mt-2" id="debris_flow_sta_table">'+
						  	'<tbody>'+
							'</tbody>'+
						'</table>'+
					'</div>' +
					'<div class="col-8">' +
						'<div class="w-100 h-450" id="debris_flow_sta_chart"></div>' +
					'</div>' +
				'</div>';
		} else {
			method_info_html_string +=
				'<h4 class="font-weight-bold">二、土石流流動模擬地圖</h4>'+
				'<div class="row">' +
					'<div class="col-5">' +
						'<h5>預測時間：' + timeConverter(this_marker.event_name.replace("(大雨專案CODIS)", "") + "00") + '</h5>' +
						'<table class="table table-bordered text-center mt-2" id="debris_flow_sta_table">'+
							'<thead class="thead-dark">'+
								'<tr>'+
									'<th scope="col" colspan="3">模擬網格深度統計</th>'+
							    '</tr>'+
								'<tr>'+
									'<th scope="col">深度</th>'+
									'<th scope="col">格數</th>'+
									'<th scope="col">影響範圍</th>'+
							    '</tr>'+
							'</thead>'+
						  	'<tbody>'+
							'</tbody>'+
						'</table>'+
					'</div>' +
					'<div class="col-7">' +
						'<div class="w-100 h-450" id="modal_map"></div>' +
					'</div>' +
				'</div>' +
				'<h4 class="font-weight-bold mt-3">三、土石流RTI即時預測資訊</h4>'+
				'<div class="row">' +
					'<div class="col-4">' +
						'<table class="table table-bordered text-center mt-2" id="debris_flow_rti_sta_table">'+
						  	'<tbody>'+
							'</tbody>'+
						'</table>'+
					'</div>' +
					'<div class="col-8">' +
						'<div class="w-100 h-450" id="debris_flow_sta_chart"></div>' +
					'</div>' +
				'</div>'
		};
		var html_string = 
			'<div class="row">'+
				'<div class="col-4">'+
					'<h4 class="font-weight-bold">一、潛勢溪流基本資料</h4>'+
					'<table class="table table-bordered text-center">'+
					  	'<tbody>'+
							'<tr>'+
								'<th scope="col">行政區</th>'+
								'<td scope="col">' + this_marker.Full.slice(3,6) + '</td>'+
						    '</tr>'+
							'<tr>'+
								'<th scope="col">村里名</th>'+
								'<td scope="col">' + this_marker.Full.slice(6,9) + '</td>'+
						    '</tr>'+
							'<tr>'+
								'<th scope="col">保全戶數</th>'+
								'<td scope="col">' + this_marker.DW_number + '</td>'+
						    '</tr>'+
							'<tr>'+
								'<th scope="col">鄰近道路</th>'+
								'<td scope="col">' + this_marker.Roadname + '</td>'+
						    '</tr>'+
							'<tr>'+
								'<th scope="col">鄰近地標</th>'+
								'<td scope="col">' + this_marker.Mark + '</td>'+
							'</tr>'+
							village_info_html +
						'</tbody>'+
					'</table>'+
				'</div>'+
				'<div class="col-8">'+
					'<img class="w-100" src="../api/debris_pic/' + this_marker.Debrisno + '.jpg">' +
				'</div>'+
				'<div class="col-12 mt-3">'+
					method_info_html_string +
				'</div>'+
				'<div class="col-12 mt-3" id="hillslope_modal_news_part">'+
					'讀取網路情資中...' +
				'</div>'+
			'</div>';
		modal_open(html_string, '<i class="fas fa-book-open"></i>「' + this_marker.Debrisno  + '」潛勢溪流坡地預警情資');
		setTimeout(function(){
			if (this_marker.event_name == "RTI即時預測") {
				$.ajax({
					url: publicPath + "/cloud/edp2/rti/" + this_marker.Debrisno,
					type: 'get',
					dataType: 'json'
				}).done(function(data) {
					var target_string = data["RainTime"].find(function(element) {
						  	return (element.match("f"));
						}),
						target_index = data["RainTime"].indexOf(target_string),
						dataset = {
							"green_block": [], "red_block": [], "scatter_point": [], "now_time_point": []
						},
						time_string_array = [];
					data["RainTime"].forEach(function(each_time, index){
						time_string_array.push(get_time_string(index + target_index));
					});
					$("#debris_flow_rti_sta_table tbody").append(
						'<tr>'+
							'<th scope="col">土石流編號</th>'+
							'<td scope="col">' + this_marker.Debrisno + '</td>'+
					    '</tr>'+
						'<tr>'+
							'<th scope="col">預測時間</th>'+
							'<td scope="col">' + this_marker.time.slice(0,13) + ":00" + '</td>'+
					    '</tr>'+
						'<tr>'+
							'<th scope="col">示警狀態</th>'+
							'<td scope="col">' + this_marker.rti_status + '</td>'+
					    '</tr>'+
						'<tr>'+
							'<th scope="col">RTI70閾值</th>'+
							'<td scope="col">' + this_marker.rti70 + '</td>'+
					    '</tr>'+
						'<tr>'+
							'<th scope="col">參考雨量站</th>'+
							'<td scope="col">' + data.StationName + "(" + data.StationID + ')</td>'+
					    '</tr>'
					);
					data["OneHour"].forEach(function(element, index){
						if (index != 0) {
							dataset["scatter_point"].push([data["ETR2"][index-1], element]);
							if (index == target_index) {
								dataset["now_time_point"].push([data["ETR2"][index-1], element]);
							}
						};
					});
					for (var i = 0; i <= 100; i++) {
						if (i == 0) {
							dataset["green_block"].push([0,0], [this_marker.rti70, i]);
							dataset["red_block"].push([this_marker.rti70, i]);
						} else if(i == 100) {
							dataset["green_block"].push([(this_marker.rti70/i), i], [0,100]);
							dataset["red_block"].push([(this_marker.rti70/i), i],[this_marker.rti70, i]);
						}else {
							dataset["green_block"].push([(this_marker.rti70/i), i]);
							dataset["red_block"].push([(this_marker.rti70/i), i]);
						}
					};
					render_block_chart({
						"div": "debris_flow_sta_chart",
						"title": this_marker.Debrisno + " RTI蛇線圖",
						"x_axis_limit": (this_marker.rti70 / 10),
						"y_axis_limit": 100,
						"x_label": "累積降雨量(mm)",
						"y_label": "時雨量(mm)",
						"green_block": dataset["green_block"],
						"red_block": dataset["red_block"],
						"scatter": dataset["scatter_point"],
						"time_label": time_string_array,
						"target_time": time_string_array[target_index],
						"scatter_time": dataset["now_time_point"]
					});
				});
			} else {
				var modal_map = new L.Map('modal_map', {
				    attributionControl: false,
				    zoom: 16,
				    zoomSnap: 1,
				    layers: L.tileLayer('https://maps.googleapis.com/maps/vt?pb=!1m5!1m4!1i{z}!2i{x}!3i{y}!4i256!2m3!1e0!2sm!3i480190100!3m14!2szh-TW!3sUS!5e18!12m1!1e68!12m3!1e37!2m1!1ssmartmaps!12m4!1e26!2m2!1sstyles!2zcy5lOmd8cC5jOiNmZjI0MmYzZSxzLmU6bC50LnN8cC5jOiNmZjI0MmYzZSxzLmU6bC50LmZ8cC5jOiNmZjc0Njg1NSxzLnQ6MTl8cy5lOmwudC5mfHAuYzojZmZkNTk1NjMscy50OjJ8cy5lOmwudC5mfHAuYzojZmZkNTk1NjMscy50OjQwfHMuZTpnfHAuYzojZmYyNjNjM2Yscy50OjQwfHMuZTpsLnQuZnxwLmM6I2ZmNmI5YTc2LHMudDozfHMuZTpnfHAuYzojZmYzODQxNGUscy50OjN8cy5lOmcuc3xwLmM6I2ZmMjEyYTM3LHMudDozfHMuZTpsLnQuZnxwLmM6I2ZmOWNhNWIzLHMudDo0OXxzLmU6Z3xwLmM6I2ZmNzQ2ODU1LHMudDo0OXxzLmU6Zy5zfHAuYzojZmYxZjI4MzUscy50OjQ5fHMuZTpsLnQuZnxwLmM6I2ZmZjNkMTljLHMudDo0fHMuZTpnfHAuYzojZmYyZjM5NDgscy50OjY2fHMuZTpsLnQuZnxwLmM6I2ZmZDU5NTYzLHMudDo2fHMuZTpnfHAuYzojZmYxNzI2M2Mscy50OjZ8cy5lOmwudC5mfHAuYzojZmY1MTVjNmQscy50OjZ8cy5lOmwudC5zfHAuYzojZmYxNzI2M2M!4e0!5m1!5f2',{
					    maxZoom: 22,
					    opacity: 1
					})
				});
				var this_geojson_data = e.layer.toGeoJSON(), 
					this_river = L.geoJson(this_geojson_data).addTo(modal_map);
				modal_map.fitBounds(this_river.getBounds());
				$.ajax({
					url: publicPath + "/cloud/edp2/debris_event/" + this_marker.event_name + "/" + this_marker.model_id,
					type: 'get',
					dataType: 'text'
				}).done(function(data) {
					if (this_marker.event_name === "2015080900") {
						data = data.replaceAll("   ", " ")
					}
					var geojson_data = ascii_to_geojson(data), 
						grid_sum_object = {"0~0.5m": 0, "0.5~1m": 0, "1~2m": 0, "2m以上": 0};
					var this_flow_layer = L.geoJson(geojson_data, {
						style: function(feature){
							var color;
							switch(true) {
							    case ((feature.properties.flow_depth > 0) && (feature.properties.flow_depth <= 0.5)):
							        color = "#fcb906";
							        grid_sum_object["0~0.5m"] += 1;
							        break;
							    case ((feature.properties.flow_depth > 0.5) && (feature.properties.flow_depth <= 1)):
							        color = "#ff620a";
							        grid_sum_object["0.5~1m"] += 1;
							        break;
							    case ((feature.properties.flow_depth > 1) && (feature.properties.flow_depth <= 2)):
							        color = "#ff620a";
							        grid_sum_object["1~2m"] += 1;
							        break;
							    case (feature.properties.flow_depth > 2):
							        color = "#840000";
							        grid_sum_object["2m以上"] += 1;
							        break;
							}
					    	return {
						        fillColor: color,
						        fillOpacity: .7,
						        weight: 0,
						        opacity: 1
						    };
						},
						onEachFeature: function(feature, layer){
							layer.bindPopup('<div class="w-180"><h5>此模擬網格深度：' + feature.properties.flow_depth.toFixed(2) + 'm</h5></div>');
						}
					}).addTo(modal_map);
					$("#debris_flow_sta_table tbody").append(
						'<tr>'+
							'<th scope="col"><i class="fas fa-square mr-2 debris-depth-text-c1"></i>0~0.5m</th>'+
							'<td scope="col">' + grid_sum_object["0~0.5m"] + '格</td>'+
							'<td scope="col">' + grid_sum_object["0~0.5m"]*400 + 'm<sup>2</sup></td>'+
					    '</tr>'+
						'<tr>'+
							'<th scope="col"><i class="fas fa-square mr-2 debris-depth-text-c2"></i>0.5~1m</th>'+
							'<td scope="col">' + grid_sum_object["0.5~1m"] + '格</td>'+
							'<td scope="col">' + grid_sum_object["0.5~1m"]*400 + 'm<sup>2</sup></td>'+
					    '</tr>'+
						'<tr>'+
							'<th scope="col"><i class="fas fa-square mr-2 debris-depth-text-c3"></i>1~2m</th>'+
							'<td scope="col">' + grid_sum_object["1~2m"] + '格</td>'+
							'<td scope="col">' + grid_sum_object["1~2m"]*400 + 'm<sup>2</sup></td>'+
					    '</tr>'+
						'<tr>'+
							'<th scope="col"><i class="fas fa-square mr-2 debris-depth-text-c4"></i>2m以上</th>'+
							'<td scope="col">' + grid_sum_object["2m以上"] + '格</td>'+
							'<td scope="col">' + grid_sum_object["2m以上"]*400 + 'm<sup>2</sup></td>'+
					    '</tr>'
					);
				});
				$.ajax({
					url: publicPath + "/cloud/edp2/rti/" + this_marker.Debrisno,
					type: 'get',
					dataType: 'json'
				}).done(function(data) {
					var target_string = data["RainTime"].find(function(element) {
						  	return (element.match("f"));
						}),
						target_index = data["RainTime"].indexOf(target_string),
						dataset = {
							"green_block": [], "red_block": [], "scatter_point": [], "now_time_point": []
						},
						time_string_array = [];
					data["RainTime"].forEach(function(each_time, index){
						time_string_array.push(get_time_string((index - target_index)*-1));
					});
					$("#debris_flow_rti_sta_table tbody").append(
						'<tr>'+
							'<th scope="col">土石流編號</th>'+
							'<td scope="col">' + this_marker.Debrisno + '</td>'+
					    '</tr>'+
						'<tr>'+
							'<th scope="col">預測時間</th>'+
							'<td scope="col">' + this_marker.time.slice(0,13) + ":00" + '</td>'+
					    '</tr>'+
						'<tr>'+
							'<th scope="col">示警狀態</th>'+
							'<td scope="col">' + this_marker.rti_status + '</td>'+
					    '</tr>'+
						'<tr>'+
							'<th scope="col">RTI70閾值</th>'+
							'<td scope="col">' + this_marker.rti70 + '</td>'+
					    '</tr>'+
						'<tr>'+
							'<th scope="col">參考雨量站</th>'+
							'<td scope="col">' + data.StationName + "(" + data.StationID + ')</td>'+
					    '</tr>'
					);
					data["OneHour"].forEach(function(element, index){
						if (index != 0) {
							dataset["scatter_point"].push([data["ETR2"][index-1], element]);
							if (index == target_index) {
								dataset["now_time_point"].push([data["ETR2"][index-1], element]);
							}
						};
					});
					for (var i = 0; i <= 100; i++) {
						if (i == 0) {
							dataset["green_block"].push([0,0], [this_marker.rti70, i]);
							dataset["red_block"].push([this_marker.rti70, i]);
						} else if(i == 100) {
							dataset["green_block"].push([(this_marker.rti70/i), i], [0,100]);
							dataset["red_block"].push([(this_marker.rti70/i), i],[this_marker.rti70, i]);
						}else {
							dataset["green_block"].push([(this_marker.rti70/i), i]);
							dataset["red_block"].push([(this_marker.rti70/i), i]);
						}
					};
					render_block_chart({
						"div": "debris_flow_sta_chart",
						"title": this_marker.Debrisno + " RTI蛇線圖",
						"x_axis_limit": (this_marker.rti70 / 10),
						"y_axis_limit": 100,
						"x_label": "累積降雨量(mm)",
						"y_label": "時雨量(mm)",
						"green_block": dataset["green_block"],
						"red_block": dataset["red_block"],
						"scatter": dataset["scatter_point"],
						"time_label": time_string_array,
						"target_time": time_string_array[target_index],
						"scatter_time": dataset["now_time_point"]
					});
				});
			};

			var address = this_marker.Full;
			$.ajax({
				url: publicPath + "/napi/emis/googleinfo?type=debris&address=" + address.replace(" ", ""),
				dataType: 'json',
				headers: {
					Authorization: 'Bearer ' + jwt_token
				}
			}).done(function(data) {
				var news_string = googleSearchInfo(data)
				$("#hillslope_modal_news_part").html(
					'<h4 class="font-weight-bold">四、網路情資(TOP10)</h4>'+
					'<h5 class="font-weight-bold"><i class="far fa-hand-point-right"></i><a target="_blank" href="https://www.google.com/search?q=新北市+土石流+' + this_marker.Full + '">點此處查看更多(關鍵字：新北市+土石流+' + this_marker.Full + ')</h5></a>'+
					news_string
				);
			});
		}, 2000);
	};
}
